import { motion, useMotionValue, useSpring } from "framer-motion";

const EASE = [0.2, 0.75, 0.25, 1];

const REVEAL_INITIAL = { opacity: 0, y: 24 };
const REVEAL_VISIBLE = { opacity: 1, y: 0 };
const REVEAL_VIEWPORT = { once: true, amount: 0.12 };
const REVEAL_TRANSITION = { duration: 0.75, ease: EASE };

export function Reveal({ as = "div", className, delay = 0, tilt = false, children, style, ...rest }) {
  const MotionTag = motion[as];
  const rx = useMotionValue(0);
  const ry = useMotionValue(0);
  const srx = useSpring(rx, { stiffness: 140, damping: 18 });
  const sry = useSpring(ry, { stiffness: 140, damping: 18 });

  const onPointerMove = tilt
    ? (event) => {
        if (!window.matchMedia("(pointer: fine)").matches) return;
        const rect = event.currentTarget.getBoundingClientRect();
        const x = (event.clientX - rect.left) / rect.width - 0.5;
        const y = (event.clientY - rect.top) / rect.height - 0.5;
        rx.set(y * -3);
        ry.set(x * 3);
      }
    : undefined;
  const onPointerLeave = tilt
    ? () => {
        rx.set(0);
        ry.set(0);
      }
    : undefined;

  return (
    <MotionTag
      className={className}
      initial={REVEAL_INITIAL}
      whileInView={REVEAL_VISIBLE}
      viewport={REVEAL_VIEWPORT}
      transition={delay ? { ...REVEAL_TRANSITION, delay } : REVEAL_TRANSITION}
      style={tilt ? { ...style, rotateX: srx, rotateY: sry, transformPerspective: 900 } : style}
      onPointerMove={onPointerMove}
      onPointerLeave={onPointerLeave}
      {...rest}
    >
      {children}
    </MotionTag>
  );
}
